

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETADMINREPORTSBYAPPRAISALYEAR= createAsyncThunk(
  "getAdminReportByAppraisalYear/getAdminReportByAppraisalYear",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAdminReportByAppraisalYearSlice = createSlice({
  name: "getAdminReportByAppraisalYearSlice",
  initialState: {
    getAdminReportByAppraisalYear: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAdminReportByAppraisalYear: (state) => {
        state.getAdminReportByAppraisalYear.loading = false
        state.getAdminReportByAppraisalYear.error = false
        state.getAdminReportByAppraisalYear.data = []
        state.getAdminReportByAppraisalYear.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETADMINREPORTSBYAPPRAISALYEAR.fulfilled, (state, action) => {
      state.getAdminReportByAppraisalYear = {
        ...state.getAdminReportByAppraisalYear,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETADMINREPORTSBYAPPRAISALYEAR.pending, (state, action) => {
      state.getAdminReportByAppraisalYear = {
        ...state.getAdminReportByAppraisalYear,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETADMINREPORTSBYAPPRAISALYEAR.rejected, (state, action) => {
      state.getAdminReportByAppraisalYear = {
        ...state.getAdminReportByAppraisalYear,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAdminReportByAppraisalYearAction = {
    GETADMINREPORTSBYAPPRAISALYEAR,
};

export { getAdminReportByAppraisalYearAction };
export default getAdminReportByAppraisalYearSlice.reducer;
export const {setInitialStateOfgetAdminReportByAppraisalYear} = getAdminReportByAppraisalYearSlice.actions
